module.exports = __webpack_public_path__ + "img/1.7e5270d6.svg";